export const passwordresetConstants = {
    GETALL_REQUEST: 'PASSWORDRESET_GETALL_REQUEST',
    GETALL_SUCCESS: 'PASSWORDRESET_GETALL_SUCCESS',
    GETALL_FAILURE: 'PASSWORDRESET_GETALL_FAILURE',

    DELETE_REQUEST: 'PASSWORDRESET_DELETE_REQUEST',
    DELETE_SUCCESS: 'PASSWORDRESET_DELETE_SUCCESS',
    DELETE_FAILURE: 'PASSWORDRESET_DELETE_FAILURE'
};
